import { combineReducers } from "redux";
import authReducer from "./authentication/reducer";
import examGroupReducer from "./exam-group/reducer";
import examReducer from "./exam/reducer";
import paperReducer from "./paper/reducer";
import subjectReducer from "./subject/reducer";
import questionsReducer from "./questions/reducer";
import topicReducer from "./auto-complete/reducer";
import sectionReducer from "./section/reducer";
import transactionsReducer from "./transactions/reducer";
import audioReducer from "./audio/reducer";
import feedbackReducer from "./feedback/reducer";
import passwordRecoveryReducer from "./password-recovery/reducer";
import facultiesReducer from "./faculties/reducer";
import departmentsReducer from "./departments/reducer";
import quizathonsReducer from "./quizathon/reducer";

export const rootReducer = combineReducers({
  auth: authReducer,
  examGroup: examGroupReducer,
  exam: examReducer,
  subject: subjectReducer,
  paper: paperReducer,
  questions: questionsReducer,
  topic: topicReducer,
  section: sectionReducer,
  transactions: transactionsReducer,
  audio: audioReducer,
  feedback: feedbackReducer,
  passwordRecovery: passwordRecoveryReducer,
  faculties: facultiesReducer,
  departments:departmentsReducer,
  quizathons:quizathonsReducer
});

export default rootReducer;
